import ProgressContainer from "../../Componant/Ui Kit/Progress/index";

const Progress = () => {
  return (
    <div className="page-body">
      <ProgressContainer />
    </div>
  );
};

export default Progress;
